<div class="content-wrapper">
  <div *ngFor="let row of content">
    <app-resource-layout [layouts]="row.layout"></app-resource-layout>
  </div>
</div>
